import Ajax from './core/Ajax'
import { removeCookie } from '@/utils/cookie'
import { localStorageService } from "@/utils/storageService"

const TOKEN_UPDATE_URLS = [
  '/api/v1/login',
  '/api/v1/register',
  '/api/v1/google/auth',
  '/api/v1/payment/after-pay/express/capture',
  '/api/v1/payment/paypal-express/capture'
]

const shouldUpdateToken = (url: string = '') => {
  return TOKEN_UPDATE_URLS.some((path) => url.includes(path))
}

//创建网络实体对象
const createAjaxInstance = (options?: any) => {
  return new Ajax({ timeout: 45000, withCredentials: true, ...options })
}

//业务网络对象
export const ajax = createAjaxInstance()

//刷新token使用(不走拦截器,避免循环问题)
export const fetch = createAjaxInstance()

//请求拦截器
ajax.axiosInstance.interceptors.request.use(
  async (config: any) => {
    const userToken = localStorageService.getItem('userToken')

    // 设置请求header
    const customHeader = {
      'Cache-Control': 'no-store',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'siteID': 2
    }
    config.headers = Object.assign({}, config.headers, customHeader)
    if (userToken) {
      config.headers.Authorization = userToken
    }

    return config
  },
  (error: unknown) => {
    return Promise.reject(error)
  }
)

//响应拦截器
ajax.axiosInstance.interceptors.response.use(
  (response: any) => {
    try {
      if (
        response.status === 200 || response.status === 201
      ) {
        if (response.data?.code <= 100000) {
          // Only auth/payment express responses should refresh the token.
          if (
            typeof window !== 'undefined'
            && response.headers['authorization']
            && shouldUpdateToken(response.config?.url || '')
          ) {
            window.localStorage.setItem('userToken', `Bearer ${response.headers['authorization']}`)
          }
          return Promise.resolve(response.data)
        } else {
          return Promise.reject(response.data)
        }
      }
      return Promise.reject(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  (error: unknown) => {
    const response =
      typeof error === "object" && error !== null && "response" in error
        ? (error as { response?: { status?: number; data?: unknown } }).response
        : undefined;

    if (response?.status === 401) {
      if (typeof window !== 'undefined') {
        localStorage.removeItem('tokenExpired')
        localStorage.removeItem('userToken')
        localStorage.removeItem('userEmail')
        removeCookie('PHPSESSID')
        removeCookie('userCustomerId')

        const currentPath = window.location.pathname + window.location.search;
        const encodedRedirect = encodeURIComponent(currentPath);
        const isCheckoutPath = window.location.pathname.startsWith('/checkout');

        if (isCheckoutPath) {
          if (window.location.pathname !== '/checkout') {
            window.location.href = '/checkout';
          }
        } else {
          window.location.href = `${process.env.API_DOMAIN}/login?redirect=${encodedRedirect}`;
        }
      }
      return Promise.reject(response.data)
    }
    
    const errorData = response?.data || { message: 'Network error or service unavailable' }
    return Promise.reject(errorData)
  }
)

export default {
  ajax,
  fetch
}
